export default class InnerDefaults {

  static resetReading() {
    this.readingMp4 = false;
    this.readingWebM = false;
    this.readingM4a = false;
    this.readingMp3 = false;
    this.readingOgg = false;
    this.readingDashShaka = false;
    this.readingHlsJS = false;
    this.readingHlsShaka = false;
    this.readingShaka = false;
    this.readingHls = false;
    this.readingFps = false;
    this.readingPDorNative = true;
    this.readingOutstream = false;
    this.readingMse = false;
  }

  static resetHasStreamType() {
    this.hasMp4 = false;
    this.hasWebM = false;
    this.hasDash = false;
    this.hasHls = false;
    this.hasFps = false;
    this.hasM4a = false;
    this.hasMp3 = false;
    this.hasOgg = false;
  }

  static set() {
    // stream type
    InnerDefaults.resetReading.call(this);
    // available src
    InnerDefaults.resetHasStreamType.call(this);
    this.innerPlayerVersion = RMP_VERSION;
    this.playerReady = false;
    this.initAlreadyCalledForThisInstance = false;
    this.hasLoadedMetadata = false;
    this.isInFullscreen = false;
    this.isVod = true;
    this.startingSrcUri = '';
    this.volumeBeforeMute = 1;
    this.msePreloadRequested = false;
    this.hlsjsInstanceCreated = false;
    this.innerAbrAutoMode = true;
    this.autoplayMode = 'unresolved';
    this.autoplayResultKnown = false;
    this.onAutoplayResultKnownFn = null;
    this.isLive = false;
    this.detectLive = true;
    this.tvPlayerSkin = false;
    this.rtl = false;
    this.posterUri = '';
    this.endOfVideoPoster = '';
    this.events = {};
    this.filteredInitialQuality = 0;
    this.initiatePlayback = null;
    this.innerControls = true;
    this.forceResetTimer = false;
    this.onVolumeChangeFn = null;
    this.postStopFn = null;
    this.isMobile = false;
    this.setSrcPDModule = false;
    this.firstDurationChange = true;
    this.endedFn = null;
    this.generateErrorFn = null;
    this.innerErrorData = null;
    this.innerWarningData = null;
    this.previousPlayerSize = {
      width: -1,
      height: -1
    };
    this.updateOverlayModuleSelectionFn = null;
    this.audioOnlyInVideoPlayer = false;
    // debug time 
    this.refTime = 0;

    this.shadowRoot = null;
    /* promise */
    this.initResolve = this.initReject = null;
    this.playResolve = this.playReject = null;
    this.setSrcResolve = this.setSrcReject = null;
    this.destroyResolve = this.destroyReject = null;
    this.fullscreenResolve = this.fullscreenReject = null;

    /* classes instances */
    // license
    this.rmpLicense = null;
    // Utils
    this.rmpUtils = null;
    // colors
    this.rmpColorsManagement = null;
    // poster
    this.rmpPosterManagement = null;
    // ready
    this.rmpReadyManagement = null;
    // accessible 
    this.rmpAccessible = null;
    // DOM
    this.rmpDomManagement = null;
    // events
    this.rmpEventsManagement = null;
    // playback
    this.rmpPlaybackManagement = null;
    // init
    this.rmpInitManagement = null;
    // size
    this.rmpSizeManagement = null;
    // volume
    this.rmpVolumeManagement = null;
    // fullscreen
    this.rmpFullscreenManagement = null;
    // seek
    this.rmpSeekManagement = null;
    // MediaSessionMetadata
    this.rmpMediaSessionMetadata = null;
    // quick
    this.rmpQuickSeekManagement = null;
    // quality
    this.rmpPDQuality = null;
    // sharing 
    this.rmpSharing = null;
    // ViewableObserver
    this.rmpViewableObserver = null;
    // logo
    this.rmpLogo = null;
    // airplay
    this.rmpAirPlay = null;
    // google cast
    this.rmpGoogleCast = null;
    this.rmpGoogleCastText = null;
    this.rmpGoogleCastHelpers = null;
    // FCC captions
    this.rmpFccCaptions = null;
    //360
    this.rmpThreeSixty = null;
    // thumbnails
    this.rmpThumbnails = null;
    // chapters
    this.rmpChapters = null;
    // cuepoints
    this.rmpCuePoints = null;
    // pip
    this.rmpPip = null;
    // floating
    this.rmpFloating = null;
    // MUX
    this.rmpMux = null;
    // logs
    this.rmpLogsManagement = null;
    // UI
    this.rmpUIManagement = null;
    // Module
    this.rmpModuleManagement = null;
    // Playlist
    this.rmpPlaylist = null;
    // Related
    this.rmpRelated = null;
    // hls.js
    this.rmpStreamingHelpers = null;
    this.rmpHlsJS = null;
    // native HLS
    this.rmpNativeHls = null;
    // Shaka player
    this.rmpShakaPlayer = null;
    this.rmpConfigureShakaPlayer = null;
    this.rmpShakaAWSMediaTailor = null;
    // API setSrc
    this.rmpApiSrc = null;
    // API destroy
    this.rmpApiDestroy = null;
    // IMA ads
    this.rmpAdsIma = null;
    // IMA DAI ads
    this.rmpAdsImaDai = null;
    // rmp-vast ads
    this.rmpAdsRmpVast = null;
    // ads helper
    this.rmpAdsHelpers = null;
    // ad scheduler
    this.rmpAdScheduler = null;
    // google analytics
    this.rmpGoogleAnalytics = null;
    // captions
    this.rmpVttJS = null;
    this.rmpCCManagement = null;
    // DVR
    this.rmpDvrManagement = null;
    // AdBlocker
    this.rmpAdBlocker = null;


    // setSrc
    this.changingSrc = false;
    // sizing
    this.hasNativeFullscreenSupport = false;
    // online/offline
    this.windowOnlineFn = null;
    this.windowOfflineFn = null;
    // playback capabilities
    this.okShaka = false;
    this.okHlsJS = false;
    this.okFps = false;
    this.okHls = false;
    this.okWebM = false;
    this.okMp4 = false;
    this.okM4a = false;
    this.okMp3 = false;
    this.okOgg = false;
    // ima values
    this.imaAdOnStage = false;
    this.contentCompleteCalled = false;
    this.imaAdLinear = false;
    this.imaAdPaused = false;
    this.imaAdID = '';
    this.imaAdSystem = '';
    this.imaAdvertiserName = '';
    this.imaAdApiFramework = '';
    this.imaAdContentType = '';
    this.imaAdCreativeAdId = '';
    this.imaAdCreativeId = '';
    this.imaAdDealId = '';
    this.imaAdDescription = '';
    this.imaAdDuration = -1;
    this.imaAdNonLinearHeight = -1;
    this.imaAdMediaUrl = '';
    this.imaAdSkipTimeOffset = -1;
    this.imaAdSurveyUrl = '';
    this.imaAdTitle = '';
    this.imaAdTraffickingParameters = null;
    this.imaAdTraffickingParametersString = '';
    this.imaAdUniversalAdIds = [];
    this.imaAdLinearHeight = 0;
    this.imaAdLinearWidth = 0;
    this.imaAdNonLinearWidth = -1;
    this.imaAdWrapperAdIds = [];
    this.imaAdWrapperAdSystems = [];
    this.imaAdWrapperCreativeIds = [];
    this.hasAdUI = false;
    this.emptyInitAdTagUrl = false;
    this.currentAdForCompanion = null;
    this.imaAdPodInfo = null;
    this.isVPAID = false;
    this.onAdDestroyLoadAdsFn = null;
    this.adDisableCustomPlaybackForIOS10Plus = false;
    this.imaAdsManager = null;
    // rmp-vast
    this.rmpVast = null;
    this.rmpVastAdPodInfo = null;
    //adblocker
    this.adParserLoaded = false;
    this.adParserLoadError = false;
    // adschedule
    this.scheduleHasMidRolls = false;
    // analytics
    this.analyticsSecondsPlayed = 0;
    // analytics API
    this.analyticsInterval = null;
    // bitmovin analytics
    this.bitmovinAnalytics = {};
    //dash
    this.shakaInstanceCreated = false;
    this.shakaPlayer = null;
    this.shakaAd = null;
    this.shakaAdManager = null;
    this.shakaOfflineStoreOperation = null;
    this.shakaPreloadManager = null;
    // HLS
    this.hlsJS = null;
    this.usingNativeHlsOnAppleDevices = false;
    this.hlsJSPreloadManager = false;
    // destroy API
    this.proceedApiDestroy = true;
    // DVR
    this.isDvrLiveMode = true;
    this.isDvr = false;
    // cast
    this.castMedia = null;
    this.castMediaTracks = null;
    this.remotePlayer = null;
    this.castSession = null;
    this.googleCastConnected = false;
    this.googleCastUrl = '';
    this.pauseRequestedByLoadCastMedia = false;
    this.googleCastInit = false;
    // captions
    this.textTracks = [];
    this.hasExternalCCFiles = false;
    this.loadedCCFiles = [];
    // related
    this.hasRelated = false;
    // playlist
    this.hasPlaylist = false;
    // meta
    this.meta = {};
    this.meta.data = {};
    this.meta.type = '';
  }
}
